import React from 'react';
import Lpbg from '../images/lp.jpg';

function LandingPageTop() {
    
    return (
        <div class="max-w-12xl relative mx-auto">
            <img src={Lpbg} className="w-full" style={{ height: 'auto' }} alt="" />
            <div class="absolute top-[200px] left-[20%]">
                <p className="text-2xl font-bold drop-shadow-[0_1.2px_1.2px_rgba(253,118,12,0.8)]" style={{ color: '#fff', fontFamily: 'MuseoSansRounded900', fontSize: 48 }}>LOREM IPSUM <span style={{ color: '#fadd04' }}>DOLOR SIT</span> AMET, <br /> <br />
                    <span style={{ color: '#fadd04' }}>CONSEC</span> ADIPISCING.</p>
            </div>

            <div class="absolute top-[400px] right-20 w-[320px] text-right">
                <p class="text-[#ff7a28] text-sm leading-relaxed">
                    Lorem ipsum dolor sit amet, consectetur adipiscing elit. Mauris nec ex
                    dolor. Proin dolor neque, pharetra id felis in, convallis aliquet mi.
                    Sed finibus eros eu justo venenatis ornare. Vivamus sed finibus orci.
                </p>
                <button class="mt-4 px-6 py-2 bg-[#ff7a28] text-white font-bold rounded-full">
                    EXPLORE
                </button>
            </div>
        </div>
    );
}

export default LandingPageTop;
